export default __webpack_public_path__ + "static/decoration-1-509eee18d82e766a7f9fc9f8f5c8c8b9.png";